import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, unref as _unref, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "space-y-4" }
const _hoisted_2 = { class: "text-sm text-black" }
const _hoisted_3 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_4 = {
  key: 1,
  class: "mb-2"
}
const _hoisted_5 = {
  key: 0,
  class: "border-t pt-4 mt-4"
}
const _hoisted_6 = { class: "space-y-3" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "flex-1" }
const _hoisted_9 = { class: "font-semibold text-black mb-1" }
const _hoisted_10 = {
  key: 0,
  class: "ml-2 text-xs bg-red-500 text-white px-2 py-0.5 rounded"
}
const _hoisted_11 = {
  key: 0,
  class: "text-xs text-red-600 mt-2"
}
const _hoisted_12 = { class: "mt-4 p-3 bg-gray-50 rounded-lg" }
const _hoisted_13 = { class: "flex items-start cursor-pointer" }
const _hoisted_14 = { class: "flex flex-row flex-wrap items-center gap-4 mt-4 pt-4 px-6 pb-4 border-t" }
const _hoisted_15 = {
  key: 1,
  class: "hidden sm:block"
}
const _hoisted_16 = { class: "ml-auto flex flex-row flex-wrap items-center justify-center gap-3 sm:justify-end" }

import { ref } from 'vue'
import { ModalComp, ActionButton } from '@/components'
import type { MelOptions, PrestationType, MelConfirmData } from '@/types/mel-components'

interface Props {
  isVisible: boolean
  title: string
  melOptions: MelOptions
  showPrestationChoice: boolean
  totalProducts: number
}

interface Emits {
  (e: 'update:isVisible', value: boolean): void
  (e: 'select-option', option: 'upload' | 'treatment' | 'shooting'): void
  (e: 'back'): void
  (e: 'confirm', data: MelConfirmData): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'MelConfirmModal',
  props: {
    isVisible: { type: Boolean },
    title: {},
    melOptions: {},
    showPrestationChoice: { type: Boolean },
    totalProducts: {}
  },
  emits: ["update:isVisible", "select-option", "back", "confirm"],
  setup(__props: any) {




const selectedPrestation = ref<PrestationType>(null)
const shootAllColors = ref(false)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ModalComp), {
    isVisible: _ctx.isVisible,
    title: _ctx.title,
    size: _ctx.showPrestationChoice ? 'xl' : 'lg',
    hideFooter: "",
    "onUpdate:isVisible": _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('update:isVisible', $event)))
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[11] || (_cache[11] = _createElementVNode("p", { class: "mb-3" }, " Pour un shooting par Efashion, veuillez cliquer sur \"Choiir le type de shooting\" puis choisir une option. ", -1)),
          (_ctx.melOptions.canUpload)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[9] || (_cache[9] = [
                _createElementVNode("strong", null, "> \"Mettre en ligne vos propres photos\" :", -1),
                _createTextVNode(" vous choisissez de mettre vos propres photos directement en ligne. ")
              ])))
            : _createCommentVNode("", true),
          (_ctx.melOptions.canTreatment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[10] || (_cache[10] = [
                _createElementVNode("strong", null, "> \"Demande de traitement\" :", -1),
                _createTextVNode(" vous envoyez vos produits physiques à Efashion pour traitement complet. ")
              ])))
            : _createCommentVNode("", true)
        ]),
        (_ctx.showPrestationChoice)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[17] || (_cache[17] = _createElementVNode("h5", { class: "font-semibold text-black mb-3" }, "Sélectionner une option", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", {
                  class: _normalizeClass(["flex items-start p-3 border rounded-lg", { 
                'bg-blue-50 border-blue-500 cursor-pointer hover:bg-gray-50': selectedPrestation.value === 'cintre' && _ctx.totalProducts <= 60,
                'bg-gray-100 border-gray-300 opacity-60 cursor-not-allowed': _ctx.totalProducts > 60,
                'cursor-pointer hover:bg-gray-50': _ctx.totalProducts <= 60
              }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    name: "prestation",
                    value: "cintre",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedPrestation).value = $event)),
                    disabled: _ctx.totalProducts > 60,
                    class: "mt-1 mr-3"
                  }, null, 8, _hoisted_7), [
                    [_vModelRadio, selectedPrestation.value]
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _cache[12] || (_cache[12] = _createTextVNode(" Cintre : GRATUIT ")),
                      (_ctx.totalProducts > 60)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Non disponible "))
                        : _createCommentVNode("", true)
                    ]),
                    _cache[13] || (_cache[13] = _createElementVNode("p", { class: "text-sm text-black" }, " Vos produits seront shootés par notre équipe dans nos studios. Les photos seront mises en ligne le lendemain du shooting. ", -1)),
                    (_ctx.totalProducts > 60)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_11, " ⚠️ Cette option gratuite est limitée à 60 références maximum par demande. Vous avez " + _toDisplayString(_ctx.totalProducts) + " références. Veuillez choisir une prestation payante ou réduire le nombre de références. ", 1))
                      : _createCommentVNode("", true)
                  ])
                ], 2),
                _createElementVNode("label", {
                  class: _normalizeClass(["flex items-start p-3 border rounded-lg cursor-pointer hover:bg-gray-50", { 'bg-blue-50 border-blue-500': selectedPrestation.value === 'efashion' }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    name: "prestation",
                    value: "efashion",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedPrestation).value = $event)),
                    class: "mt-1 mr-3"
                  }, null, 512), [
                    [_vModelRadio, selectedPrestation.value]
                  ]),
                  _cache[14] || (_cache[14] = _createElementVNode("div", { class: "flex-1" }, [
                    _createElementVNode("div", { class: "font-semibold text-black mb-1" }, "Exclusive Efashion : 4.00€"),
                    _createElementVNode("p", { class: "text-sm text-black" }, " *4.00€ HT la couleur par référence photos, prise et mise en ligne dans la semaine suivant la demande avec droit de diffusion sur Efashion uniquement (site Ecommerce b2b) ")
                  ], -1))
                ], 2),
                _createElementVNode("label", {
                  class: _normalizeClass(["flex items-start p-3 border rounded-lg cursor-pointer hover:bg-gray-50", { 'bg-blue-50 border-blue-500': selectedPrestation.value === 'libredroit' }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    name: "prestation",
                    value: "libredroit",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedPrestation).value = $event)),
                    class: "mt-1 mr-3"
                  }, null, 512), [
                    [_vModelRadio, selectedPrestation.value]
                  ]),
                  _cache[15] || (_cache[15] = _createElementVNode("div", { class: "flex-1" }, [
                    _createElementVNode("div", { class: "font-semibold text-black mb-1" }, "Libre utilisation : 6.00€"),
                    _createElementVNode("p", { class: "text-sm text-black mb-2" }, [
                      _createTextVNode(" *6.00€ HT la couleur par référence photos, prise et mise en ligne dans la semaine suivant la demande. Après une semaine d'exclusivité sur le site Efashion, un lien de téléchargement sera disponible sur la ligne de la demande. "),
                      _createElementVNode("strong", null, "Pendant cette semaine, il n'est pas possible d'utiliser les photos sur d'autres plateformes. Si cela arrive, des sanctions pourront être appliquées.")
                    ])
                  ], -1))
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((shootAllColors).value = $event)),
                    class: "mt-1 mr-3 rounded"
                  }, null, 512), [
                    [_vModelCheckbox, shootAllColors.value]
                  ]),
                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "flex-1" }, [
                    _createElementVNode("span", { class: "text-sm text-black" }, [
                      _createElementVNode("strong", null, "Toutes les couleurs"),
                      _createTextVNode(" (si coché, chaque couleur sera photographiée séparément. Sinon, seule la couleur principale sera photographiée) ")
                    ]),
                    _createElementVNode("p", { class: "text-xs text-black mt-1 italic" }, " 💰 Attention : Pour les prestations payantes (Exclusive Efashion / Libre utilisation), le prix est multiplié par le nombre de couleurs shootées. ")
                  ], -1))
                ])
              ]),
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "mt-4 text-xs text-black italic p-3 bg-yellow-50 border border-yellow-200 rounded" }, [
                _createElementVNode("strong", null, "Concernant les droits d'image des mannequins"),
                _createTextVNode(", nous vous informons que les photos sont uniquement destinées à des fins commerciales. Efashion se réserve le droit d'interdire toute utilisation ne respectant pas l'intégrité de la mannequin. ")
              ], -1))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          (_ctx.showPrestationChoice && !_ctx.melOptions.mustChooseShooting)
            ? (_openBlock(), _createBlock(_unref(ActionButton), {
                key: 0,
                label: "Retour",
                icon: "fas fa-arrow-left",
                variant: "secondary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('back')))
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_15)),
          _createElementVNode("div", _hoisted_16, [
            (_ctx.melOptions.button1Available && !_ctx.showPrestationChoice)
              ? (_openBlock(), _createBlock(_unref(ActionButton), {
                  key: 0,
                  label: _ctx.melOptions.button1Label,
                  variant: "primary",
                  customClass: "w-auto",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('select-option', _ctx.melOptions.canUpload ? 'upload' : 'treatment')))
                }, null, 8, ["label"]))
              : _createCommentVNode("", true),
            (!_ctx.showPrestationChoice)
              ? (_openBlock(), _createBlock(_unref(ActionButton), {
                  key: 1,
                  label: "Choisir le type de shooting",
                  variant: "secondary",
                  customClass: "w-auto",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('select-option', 'shooting')))
                }))
              : _createCommentVNode("", true),
            (_ctx.showPrestationChoice)
              ? (_openBlock(), _createBlock(_unref(ActionButton), {
                  key: 2,
                  label: "Confirmer",
                  variant: "primary",
                  disabled: !selectedPrestation.value || (selectedPrestation.value === 'cintre' && _ctx.totalProducts > 60),
                  customClass: "w-full sm:w-auto",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('confirm', { prestation: selectedPrestation.value, shootAllColors: shootAllColors.value })))
                }, null, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["isVisible", "title", "size"]))
}
}

})